import { getMultiSelectFieldDetails, setMultiSelectField } from "../../../apiclients/streamsapi_bridge";

export async function getMultiSelectRequest(id, agents, moduleType) {
    try {
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        const update = {
            reqid: 89,
            siteid,
            option_type: parseInt(id),
            module_type: moduleType,
            ...(typeof agents?.[0] === "string"
                ? { uniqueids: agents }
                : { all_group_ids: agents })
        };
        const response = await getMultiSelectFieldDetails(update, moduleType);
        if (!response) {
            return;
        }
        const multiSelectResponse = await response.json();
        console.log("reposnse for the multi request is ::::::: " + JSON.stringify(multiSelectResponse));
        return multiSelectResponse;


    } catch (error) {
        console.log(`Error in getMultiSelectRequest :::: ${error}`);

    }
    return "";
}

export async function setMultiSelectValue(id, slectedId, agents, moduleType, flag, confirmFlag, restrictAddon, groupType) {
    try {
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        const update = {
            reqid: 90,
            siteid: siteid,
            option_type: parseInt(id),
            ...(typeof agents?.[0] === "string"
                ? { uniqueids: agents }
                : { all_group_ids: agents }),
            module_type: moduleType,
            ...((groupType >= 0) ? { group_type: groupType } : {})
        }

        if (slectedId && slectedId !== "") {
            update.option_value = slectedId;
        }
        if (flag) {
            update.save_flag = 1;
        }
        if (restrictAddon != undefined) {
            update.restrict_addons_purchase = restrictAddon
        }

        console.log("request for the set multi select value is ::::::: " + JSON.stringify(update));
        const response = await setMultiSelectField(update, moduleType, confirmFlag);
        if (!response) {
            return;
        }
        const multiSelectResponse = await response.json();
        console.log("reposnse for the set multi select value is ::::::: " + JSON.stringify(multiSelectResponse));
        return multiSelectResponse;


    } catch (error) {
        console.log(`Error in getMultiSelectRequest :::: ${error}`);

    }
    return "";
}